export const STATIONS_STATE = 'STATIONS_WITH_PRICES';

export const STATIONS_AMPLITUDE_EVENTS = {
  openFavouriteServicePoints: 'openFavouriteServicePoints',
  searchFavouriteServicePoints: 'searchFavouriteServicePoints',
  addFavouriteBrand: 'addFavouriteBrand',
  deleteFavouriteBrand: 'deleteFavouriteBrand',
  addFavouriteServicePoint: 'addFavouriteServicePoint',
  deleteFavouriteServicePoint: 'deleteFavouriteServicePoint',
  buildRouteThroughFavouriteServicePoint: 'buildRouteThroughFavouriteServicePoint'
} as const;


export const ChargePriceType = {
  None: 0,
  NetPrice: 1,
  GrossPrice: 2,
  NetExcise: 3,
};
